import { api } from './client';
import type { Env, JournalData, PurgeBatchResult, PurgeItemResult, RestoreResult } from '../types';

/** Re-authentification Google avant une action destructrice (voir requireStepUp cote API). */
export function stepUp(credential: string) {
  return api<null>('/auth/step-up', { method: 'POST', body: JSON.stringify({ credential }) });
}

export function fetchJournal(env: Env) {
  return api<JournalData>(`/purge/journal?env=${env}`);
}

export function runPurge(
  env: Env,
  payload: {
    ruleId: string | null;
    devices: number[];
    places: number[];
    mqtt: number[];
    confirmCount: number;
  }
) {
  return api<PurgeBatchResult<PurgeItemResult>>(`/purge?env=${env}`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function restoreEntries(env: Env, ids: number[]) {
  return api<PurgeBatchResult<RestoreResult>>(`/purge/restore?env=${env}`, {
    method: 'POST',
    body: JSON.stringify({ ids }),
  });
}
